import moment from 'moment';
import { TransactionReceiptResult, TransactionResult } from '../api-results/transaction.api-result';
import { TransactionStatus } from '../enums/transaction.enum';

export class Transaction {
  id: string;
  createdAt: Date;
  paymentIntentId: string;
  amount: number;
  status: TransactionStatus;

  // nnkitodo [later] eurk
  loading = false;

  constructor(result: TransactionResult) {
    this.id = result.id;
    if (result.createdAt) this.createdAt = moment(result.createdAt).toDate();
    this.paymentIntentId = result.paymentIntentId;
    this.amount = result.amount;
    this.status = result.status;
  }
}

export class TransactionReceipt {
  receiptUrl: string;

  constructor(result: TransactionReceiptResult) {
    this.receiptUrl = result.receiptUrl;
  }
}
